import { cn } from '@/utils';
import { ISimulationPlanningCardContentSection } from '@/types';
import { TextParagraphBodyMedium } from '@/components/Text';
import React from 'react';

interface Props {
  section: ISimulationPlanningCardContentSection;
}

/**
 * ContentDescription
 *
 * Renders the description text for a planning card content section. If no
 * description is provided, this component renders nothing.
 */
export const ContentDescription: React.FC<Props> = ({ section }) => {
  const { description } = section ?? {};

  if (!description) {
    return null;
  }

  return (
    <TextParagraphBodyMedium
      className={cn('!leading-6', { '-mb-4': section?.items?.length })}
      color="neutral-gray-800"
      data-key="section.description"
      text={description}
      weight="bold"
      align="left"
    />
  );
};
